import { render, staticRenderFns } from "./next-collection.vue?vue&type=template&id=fbb0f1ba&scoped=true&"
import script from "./next-collection.vue?vue&type=script&lang=js&"
export * from "./next-collection.vue?vue&type=script&lang=js&"
import style0 from "./next-collection.vue?vue&type=style&index=0&id=fbb0f1ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb0f1ba",
  null
  
)

export default component.exports